import Filters from '@components/Filters/Filters';
import Footer from '@components/Footer';
import LeftNavbar from '@components/LeftNavBar';
import TopNavbar from '@components/TopNavBar';
import { useAppSelector } from '@store/hooks';
import { useState } from 'react';

import {
  ContentWrapper,
  LeftSideBarContainer,
  MainContent,
  MainWrapper,
  NavBarContainer,
} from './styles';
import { Props } from './types';

const Layout = ({ children, addFiltersComponent = true }: Props) => {
  const SIDEBAR_STORAGE_KEY = 'sidebarOpen';

  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() => {
    const saved = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return saved !== null ? JSON.parse(saved) : true;
  });

  const handleSidebarToggle = (
    value: boolean | ((prev: boolean) => boolean),
  ) => {
    setIsSidebarOpen((prev) => {
      const next = typeof value === 'function' ? value(prev) : value;
      localStorage.setItem(SIDEBAR_STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return (
    <MainWrapper className="main-wrapper-content">
      <LeftSideBarContainer $isOpen={isSidebarOpen}>
        <LeftNavbar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={handleSidebarToggle}
        />
      </LeftSideBarContainer>
      <ContentWrapper $isOpen={isSidebarOpen}>
        <NavBarContainer>
          <TopNavbar />
          {isAuthenticated && addFiltersComponent && <Filters />}
        </NavBarContainer>
        <MainContent className="main-content">{children}</MainContent>
        <Footer />
      </ContentWrapper>
    </MainWrapper>
  );
};

export type { Props };
export default Layout;
